
import { RecycleScroller } from 'vue-virtual-scroller'
import LoadingPlaceholder from '../../UIShared/LoadingPlaceholder.vue'
import ConversationSearchResult from './ConversationSearchResult.vue'

import 'vue-virtual-scroller/dist/vue-virtual-scroller.css'

const CONVERSATION_ITEM_SIZE = 66

export default {
	name: 'ConversationsSearchListVirtual',

	components: {
		LoadingPlaceholder,
		ConversationSearchResult,
		RecycleScroller,
	},

	props: {
		conversations: {
			type: Array,
			required: true,
		},

		loading: {
			type: Boolean,
			default: false,
		},
	},

	emits: ['select'],

	setup() {
		return {
			CONVERSATION_ITEM_SIZE,
		}
	},

	methods: {
		onClick(item) {
			this.$emit('select', item)
		},
	},
}
